/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from 'vue';
import Axios from 'axios';
import { Model } from 'vue-api-query';
import store from '@/store';
import { ADD_SERVER_ERROR, ADD_SERVER_SUCCESS } from '@/store/modules/common/mutation-types';

Axios.defaults.baseURL = process.env.API_LOCATION;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
  (response) => {
    store.dispatch('common/updateVersion', response.headers);
    store.commit(`common/${ADD_SERVER_SUCCESS}`, response.data);
    store.dispatch('wait/end', 'global loading', { root: true });
    return response;
  },
  (error) => {
    store.dispatch('common/updateVersion', error.response.headers);

    if (error.response.status === 401 || (error.response.data.message === 'Unauthenticated.' && error.response.status === 500)) {
      store.dispatch('auth/logout', true);
    }

    store.commit(`common/${ADD_SERVER_ERROR}`, error.response.data);
    store.dispatch('wait/end', 'global loading', { root: true });

    return Promise.reject(error);
  });

// Bind Axios to Vue.
Vue.$http = Axios;
Model.$http = Axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});



// WEBPACK FOOTER //
// ./src/plugins/axios.js